import heroImgDesktop from 'assets/images/productPages/prose-custom-hair-products-desktop.jpg';
import heroImgDesktopWithScalpSerum from 'assets/images/productPages/prose-custom-hair-products-desktop-with-scalp-serum.jpg';
import heroImgMobile from 'assets/images/productPages/prose-custom-hair-products-mobile.jpg';
import heroImgMobileWithScalpSerum from 'assets/images/productPages/prose-custom-hair-products-mobile-with-scalp-serum.jpg';
import skincareImgDesktop from 'assets/images/productPages/prose-custom-skincare-products-desktop.jpg';
import skincareImgMobile from 'assets/images/productPages/prose-custom-skincare-products-mobile.jpg';
import accessoriesImgDesktop from 'assets/images/productPages/prose-hair-accessories-collection-desktop.jpg';
import accessoriesImgMobile from 'assets/images/productPages/prose-hair-accessories-collection-mobile.jpg';
import supplementsDesktop from 'assets/images/productPages/supplements_collectionD.jpg';
import supplementsMobile from 'assets/images/productPages/supplements_collectionMT.jpg';

export const hairCareCollection = {
  hero: {
    imageDesktop: heroImgDesktop,
    imageMobile: heroImgMobile,
    imageDesktopWithScalpSerum: heroImgDesktopWithScalpSerum,
    imageMobileWithScalpSerum: heroImgMobileWithScalpSerum,
    color: 'noir',
    headline: 'Custom haircare and supplements',
    consultationCta: {
      hasNotStartedConsultation: {
        dataFrom: 'consultation-haircare',
        dataClick: 'PLP-hero',
        label: 'Get your formula',
        url: '/consultation/haircare',
      },
      hasStartedConsultation: {
        dataFrom: 'finish-consultation-haircare',
        dataClick: 'PLP-hero',
        label: 'Finish your consultation',
        url: '/consultation/haircare/my-hair/age',
      },
      hasCompletedConsultation: {
        dataFrom: 'haircart-cart',
        dataClick: 'PLP-hero',
        label: 'Order your Prose',
        url: '/checkout/haircare',
      },
    },
  },
  seoBlurb: {
    headline: 'Always made to order, always just for you',
    subHead:
      'Every Prose hair product is formulated according to 85+ unique factors from your in-depth consultation — for truly custom haircare and always-improving results. From shampoo and conditioner to masks, treatments, and styling products, your personalized haircare routine is tailored to your specific goals for healthy, nourished hair from root to tip.',
  },
  featured: {
    supplements: {
      imgMobile: supplementsMobile,
      imgDesktop: supplementsDesktop,
      title: (
        <>
          Discover your Root Source<sup>®</sup> for fuller, stronger, softer hair.
        </>
      ),
      ctaLabel: 'MEET THE SUPPLEMENTS',
      url: '/pages/supplements',
    },
    accessories: {
      imgAlt: 'Assortment of Prose accessories',
      imgMobile: accessoriesImgMobile,
      imgDesktop: accessoriesImgDesktop,
      title: 'Elevate your routine',
      ctaLabel: 'Explore Accessories',
      url: '/products/accessories',
      dataFrom: 'explore-accessories',
      dataClick: 'PLP-upsell',
    },
    skincare: {
      imgAlt: 'Prose custom skincare products',
      imgMobile: skincareImgMobile,
      imgDesktop: skincareImgDesktop,
      title: 'Discover custom skincare',
      ctaLabel: 'explore skincare',
      url: '/pages/skincare',
      dataFrom: 'explore-skincare',
      dataClick: 'PLP-upsell',
    },
  },
};
